import React, { Component } from 'react';
import styled from 'styled-components';
import { onResize } from '@/shared/functions';
const TextCenter = styled.div `
  text-align: center;
  color: #fff;
`;
const Root = styled(TextCenter) `
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #000537;
  .title1, .title2 {
    font-size: 0.48rem;
  }
  .title1 {
    margin-bottom: 0.2rem;
  }
`;
class EndAction extends Component {
    constructor() {
        super(...arguments);
        /**
         * @desc 窗口变更调用的函数
         */
        this.onResize = () => {
            // 实际区域宽高
            const designSizeH = 606;
            onResize('_sessionEnd', designSizeH);
        };
    }
    componentWillMount() {
        // 设置html rem值
        window.addEventListener('resize', this.onResize, false);
    }
    componentDidMount() {
        this.onResize();
        // 处理计算不准确的问题
        setTimeout(() => {
            this.onResize();
        }, 0);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize, false);
    }
    render() {
        return (<Root id="_sessionEnd">
        <div className="position__Abs-center">
          <div className="title1">本场拍卖已结束</div>
          <div className="title2">感谢您的参与</div>
        </div>
      </Root>);
    }
}
export default EndAction;
